import { useAuth } from '@hooks/useAuth';
import { SignInForm } from './components/SignInForm';
import Spinner from '@components/Spinner';

function SignIn() {
  const { requested } = useAuth();
  return (
    <div className="w-100 vh-100 d-flex flex-column align-items-center overflow-auto">
      {requested ? (
        <div className="w-100 h-100 d-flex justify-content-center align-items-center">
          <Spinner />
        </div>
      ) : (
        <div className="w-100 h-100">
          <SignInForm />
        </div>
      )}
    </div>
  );
}

export default SignIn;
